/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../../widgets/livewidget/nls/StringResources',
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit'
], function(stringResources, React, PropTypes, Toolkit) {
	const { ToggleSwitch, Label, Tooltip, FlexLayout, FlexItem } = Toolkit;
	const ForecastTitleDiv = (props) => {
		const label = stringResources.get('forecast_title');
		let toggle = <ToggleSwitch
			className={props.toggleEnabled ? 'forecastTitleToggle is-checked': 'forecastTitleToggle'} // classname is used in functional test
			checked={props.toggleEnabled}
			onChange={props.onToggleChange}
			small={true}
			align='center'
		/>;
		const toggleTooltipLabel = props.toggleEnabled ? stringResources.get('forecast_toggle_off') : stringResources.get('forecast_toggle_on');
		let toggleSection = toggle ? <Tooltip title={toggleTooltipLabel} orient='top'>
			{toggle}
		</Tooltip> : null;
		return (
			<div>
				<FlexLayout flexDirection='row' justifyContent='space-between'>
					<FlexItem className='forecastLabel'>
						<Tooltip title={label} orient='top'>
							<Label
								className='forecastLabel'
								label={label}
							/>
						</Tooltip>
					</FlexItem>
				</FlexLayout>
				<FlexLayout flexDirection='row' justifyContent='space-between'  alignItems='center' className='forecastSubLabelSection'>
					<FlexItem>
						<Label
							className='forecastSubLabel'
							label={stringResources.get('forecast_show')}
						/>
					</FlexItem>
					<FlexItem>
						{toggleSection}
					</FlexItem>
				</FlexLayout>
			</div>
		);
	};
	ForecastTitleDiv.propTypes = {
		toggleEnabled: PropTypes.bool,
		onToggleChange: PropTypes.func
	};
	return ForecastTitleDiv;
});
